

function OpenAccountPaymentButton(){
    $(document).on("submit", "#CardForm", function (e) {
        e.preventDefault();
        $.ajax({
            type: 'post',
            url: $("#CardForm").attr("action"),
            data: $("#CardForm").serialize(),
            async: true,
            success: function (dt) {
                if(dt == "true"){
                    document.location.href = "/tr/p/User/PayGaranti3DSecureResultForOpenAccount";
                } else {
                    $(".ErrorArea").html('<div class="alert alert-danger">' + dt + '</div>');
                }
               
            },
            error: function () {
                $(".ErrorArea").html('<div class="alert alert-danger">Bir Hata Oluştu Lütfen Tekrar Deneyimniz.</div>');
            }
        });


    });


    $(document).on("click", "#OpenAccountPaymentTable .PaymentDetails", function () {

        var ID = $(this).data("id");

        if (ID != undefined && ID != '')
        {
            $.ajax({
                type: 'get',
                url: '/tr/p/User/OpenAccountPaymentResult?ID='+ID,
                async: true,
                success: function (dt) {
                    $("#OpenAccountPaymentDetails .modal-body").html("");
                    $("#OpenAccountPaymentDetails .modal-body").html(dt);
                    $("#OpenAccountPaymentDetails").modal();
                },
                error: function () {
                    alert("Bir Hata Oluştu Lütfen Tekrar Deneyiniz");
                }
            });
    
        }
        

    });



}

function ReturnOrder() {



    $(document).on("click", ".CancelOrder", function (e) {

        $(this).removeAttr("disabled", "disabled");
        $(this).removeClass("disabled");
        $('#MyOrderModal').find(".yes").attr("data-ajax", $(this).attr("data-ajax"));

    });

    $(document).on("click", "#MyOrderModal .yes", function () {
        $(this).attr("disabled", "disabled");
        $(this).addClass("disabled");
        $.ajax({
            type: "GET",
            url: $(this).attr("data-ajax"),
            success: function (data) {
                //console.log(data);
                if (data.Sonuc) {
                    $("#MyOrderModal").modal("toggle");
                    $("#UserAlertsModal .modal-body").html("Sipariş iptal talebi Alındı incelenerek dönüş yapılacaktır.");
                    $("#UserAlertsModal .modal-title").html("Sipariş İptal Talebi Alındı");
                    $("#UserAlertsModal").delay(500).modal("toggle");
                    
                } else {
                    $("#MyOrderModal").modal("toggle");
                    $("#UserAlertsModal .modal-title").html("Bir Hata Oluştu");
                    $("#UserAlertsModal .modal-body").html("Bir Hata oluştu lütfen daha sonra tekrar deneyiniz.");
                    $("#UserAlertsModal").delay(500).modal("toggle");
                }
            }
        });
        
    });
   
}

function LoadCargoEvents(){



        $(document).on("click", "a.CargoDetailModal", function (event) {

            event.preventDefault();

            var x = $(this);
            var OrderModal = $("div#long");
            var ModalTitle = $("h3.modal-title", OrderModal);
            var ModalContent = $("div.modal-body", OrderModal);

            var CurrentTitle = $(x).children("td:first").html();
            
            $(ModalContent).html("<div class='mloader'><img src='/Images/OXB2B/AjaxGrid.gif'></div>")

            $(ModalTitle).html($("h3.ModalTitle").text());
            
            $.ajax({
                type: "GET",
                url: x.attr("data-trackFile"),
                success: function (data) {
                    $(ModalContent).find(".mloader").remove();
                    $(ModalContent).html(data);
                }
            });

        });
  
}




$(document).ready(function () {
      

    OpenAccountPaymentButton();

    LoadCargoEvents();
    ReturnOrder();

    $("a.AjaxLink").live("click", function () {

        var callUrl = $(this).attr("href");
        var dynform = $(this).attr("data-dynform");

        $DynformDiv = $("div." + dynform + ":first");

        var dt = "";

        $.ajax({
            type: "GET",
            url: callUrl,
            success: function (data) {

                dt = data;
                $DynformDiv.html(data);


                // Adres formunda fatura bilgileri inputları için
                if ($("#AdresTipi2").is(":checked")) {
                    $(".vergi").show(); $(".tcno").hide();
                }

                if ($("#AdresTipi1").is(":checked")) {
                    $(".vergi").hide(); $(".tcno").show();
                }

                if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                    || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                    $(".tr_group").show();
                    $(".stateDiv").hide();
                    $(".cityDiv").hide();

                }

                if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                    &&
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                    $(".tr_group").hide();
                    $(".stateDiv").hide();
                    $(".cityDiv").show();

                }
                if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                    ||
                    $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                    $(".tr_group").hide();
                    $(".stateDiv").show();
                    $(".cityDiv").show();

                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });



        return false;

    });
     
    $(".PassChange").live("click", function () {

        $.ajax({
            type: 'POST',
            url: '/' + $("#SmallLangCode").val() + '/p/User/ChangePass',
            data: $(".ChangePassForm").serialize(),
            success: function (dt) {
                $(".cp").html(dt);
            }
        });

        return false;

    });
     
    $("form.davetform").live("submit", function (e) {

        $form = $(this);

        $.ajax({
            type: $form.attr("method"),
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (data) {

                if ($('.validation-summary-errors').length) {

                    $('.validation-summary-errors')
                        .addClass('alert alert-error');
                }

                $(".AjaxLoader").hide();

                if (data.Sonuc != true) {

                    $form.find(".jsCreated").remove();
                    $form.prepend('<div class="validation-summary-errors alert alert-error jsCreated" data-valmsg-summary="true"><ul><li> ' + data.IslemSonucAciklama + ' </li></ul></div>');

                    return false;
                }
                else {

                    $form.find("div.jsCreated, .validation-summary-valid").remove();
                    $('<div class="validation-summary-valid alert alert-success jsCreated gizle" data-valmsg-summary="true"><ul><li> ' + data.IslemSonucAciklama + '</li></ul></div>').insertBefore($form).slideDown("slow");

                    $(".temizle").val('');


                }


            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        e.preventDefault;
        return false;

    });



    $("form.UserMessageForm").live("submit", function () {

        $(".AjaxLoader").show();

        $.ajax({
            type: $(this).attr("method"),
            url: $(this).attr("action"),
            data: $(this).serialize(),
            cache: false,
            success: function (data) {
                console.log(data);

                $(".MessageBody").html(data);

                $(".AjaxLoader").hide();
            }
        });

        return false;

    });



    if (document.URL.indexOf("/p/User/") > -1 || document.URL.indexOf("/p/Orders/") > -1) {

        $(".grey .menuitem a").each(function (index) {

            var CurUrl = document.URL.split('/p/User/')[1];

            var CurLink = "";

            if (document.URL.indexOf("/p/Orders/") > -1) {

                CurUrl = document.URL.split('/p/Orders/')[1];
                CurLink = $("#SmallLangCode").val() + "/p/Orders/" + $("#AName").val();

            }
            else {
                CurLink = $("#SmallLangCode").val() + "/p/User/" + $("#AName").val();

            }

            if ($(this).attr("href").indexOf(CurLink) > 0) {

                if ($(this).attr("href").indexOf("hb=t") < 0) {
                    $(this).closest("li").addClass("current");

                }
                else if ($(this).attr("href").indexOf("hb=t") > 0 && document.URL.indexOf("hb=t") > -1) {
                    $(".grey li").removeClass("current");
                    $(this).closest("li").addClass("current");
                }
            }

        });

        $(".ToggleAccountMenu").html($(".menuitem.current:first").text() + "<span></span>");

        if($(".menuitem.current:first").length<=0)
        {
            $(".ToggleAccountMenu").html($(".menuitem:first").text() + "<span></span>");
        }
    }

    if ($(".HighlightLinkFromUrl").length > 0) {

        $(".HighlightLinkFromUrl a").each(function (index) {

            var CurLink = $("#CName").val() + "/" + $("#AName").val();

            if ($(this).attr("href").indexOf(CurLink) > 0) {
                $(this).addClass("active");
                $(this).parent().addClass("active");
            }

        });

    }

    $('.ToggleAccountMenu').click(function () {
        $(this).toggleClass("open");
        $(".AccountMenu").toggleClass("open");

    });

    PhoneFormatAccount();
});

function PhoneFormatAccount() {

    //$("#localPassVM_User_Gsm").mask("9999 999 99 99");
}